import { useApiIsLoaded, useApiLoadingStatus } from '@vis.gl/react-google-maps';

export function useGoogleMapsLoader() {
  const isLoaded = useApiIsLoaded();
  const status = useApiLoadingStatus();
  const loadError =
    status === 'FAILED' || status === 'AUTH_FAILURE'
      ? new Error(status)
      : undefined;
  return { isLoaded, loadError, status };
}
